import { PromoCodeWithCharges } from 'app/shared/typings/promoCodes';

export const calculateDiscountAmount = (
  price: number,
  numberOfTickets: number,
  promoCode?: PromoCodeWithCharges
): number => {
  if (!promoCode || !promoCode.isValid) {
    return 0;
  }

  return Number(
    price * numberOfTickets -
      promoCode.charges[numberOfTickets - 1].amount / 100
  );
};

export const calculateNumberOfFreeTickets = (
  promoCode: PromoCodeWithCharges
): number => {
  if (!promoCode || !promoCode.isValid || !promoCode.charges) {
    return 0;
  }

  return promoCode.charges.filter((charge: any) => charge.amount === 0).length;
};
